import React from 'react';

interface CustomProps {
  onClick: (name: string) => void;
  label: string;
  isOpen?: boolean;
  title?: string;
  className?: string;
}

export const AccordionSection: React.FunctionComponent<CustomProps> = (
  props
) => {
  const onClick = () => {
    props.onClick(props.label);
  };

  return (
    <div
      className={`accordion__panel ${
        props.isOpen ? 'accordion__panel--open' : ''
      } ${props.className ? 'mb-2' : ''}`}
    >
      <div
        onClick={onClick}
        className={`d-flex  align-items-center py-2  accordion__head ${
          props.className || 'px-4 border-bottom'
        }`}
      >
        <h6 className="mb-0">{props.label}</h6>
        {props.title && (
          <span className="bg-green ml-2 font-xxxs text-uppercase px-2 text-white">{props.title}</span>
        )}
        <i
          className={`align-items-center border cursor-pointer d-flex icon-box justify-content-center ml-auto ${
            props.isOpen ? ' icon-chevron-up' : ' icon-chevron-down'
          } `}
        ></i>
      </div>
      {/* {props.isOpen && ( */}

      {props.children}

      {/* )} */}
    </div>
  );
};

export default AccordionSection;
